
	export default { name: 'VDropdownDivider' } // name the component
